import * as e from "react";
const v = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M19 2v2h-2v3a3 3 0 013 3v11a1 1 0 01-1 1H5a1 1 0 01-1-1V10a3 3 0 013-3V4H5V2h14zm-2 7H7a1 1 0 00-1 1v10h12V10a1 1 0 00-1-1zm-4 2v2h2v2h-2v2h-2v-2H9v-2h2v-2h2zm2-7H9v3h6V4z" }));
export {
  v as ReactComponent
};
